









import { Vue, Component, Prop } from "vue-property-decorator";
@Component({
  name: "AgroRatingIcon",
})
export default class AgroRatingIcon extends Vue {
  
  @Prop({ type: Number, default: 0 }) 
  public rating = 0;

  @Prop({ type: String, default: '' })
  public label = '';

  @Prop({ type: Array, default: [1, 2, 3] }) 
  public ticks = [1, 2, 3]
  
  @Prop({ type: String, default: "" }) 
  public color = '';

  getStyle(tick: number) {
    return { 
      'background-color': this.rating >= tick ? this.color : 'inherit', 
    }
  }

}
